const euCountries = ['at', 'be', 'bg', 'hr', 'ch', 'cy', 'cz', 'dk', 'ee', 'fi', 'fr', 'de', 'gr', 'hu', 'ie', 'it', 'lv', 'lt', 'lu', 'mt', 'nl', 'pl', 'pt', 'ro', 'sk', 'si', 'es', 'se'];
const honoraryEuCountries = ['gb', 'ch'];

export function isInEU(countryCode) {
	if (!countryCode || typeof countryCode !== 'string') return false;
	const lower = countryCode.toLowerCase();
	if (euCountries.includes(lower)) {
		return true;
	}
	if (honoraryEuCountries.includes(lower)) {
		return 'honorary';
	}
	return false;
}